export const WORD_LENGTH = 12;
